import React, { useState } from "react";
import Data_config from "./Data_config";
import "../Css/Test.css";
import worldcom_pic from "../images/HOW.jpg";

function Test() {
  const [readMore1, setReadMore1] = useState(false);


  const linkName1 = readMore1
    ? "Read less  "
    : " 1) Social Hackers Academy ... ";

  return (
    <div className="sepNav">
      <div className="row1">
        {Data_config.How_To_Use.map((get_data) => {
          return (
            <div>
              <img src={worldcom_pic} alt="worldcom_pic" />

              <div className="row1">
                <div className="row1">
                  <div
                    className="history col-xs-10 col-sm-8 col-md-10"
                    style={{ paddingBottom: "100px" }}
                  >
                    <h1 className="H1_a">How to use WorldCom?</h1>

                    <p className="text-justify">
                      How to use WorldCom? It’s very simple to use world-com!{" "}
                      <br />
                      Step 1: <br />Go to the this <a href="https://worldcom-5bb9d.web.app/">
                      URL

                      </a>  and then in this URL you will
                      see two buttons, one for sign-up and one for sign-in, if
                      you don't have an account please click on the

                      <a href="https://worldcom-5bb9d.web.app/Newregisterfile">
                      sign-up

                      </a>  

                      button to create an account.
                      <br />
                      and if you already have an account please click on the

                      <a href="https://worldcom-5bb9d.web.app/login"> 
                      sign-in 
                      </a>

                      button and use your email address and password to
                      login into the application.
                      <br />
                      Step 2: <br />If you created an
                      account and forgot your password, please create a new
                      account. 
                      <br />
                      Step 3:<br /> To have access to the courses and
                      projects, after singing in click on the sidebar and then
                      click “Get My courses” and then click on the “ReactJs” and
                      then it will open a new page you will see all the courses.
                    </p>

                    <hr
                      style={{
                        paddingTop: "1px",
                        borderTop: "1px solid black",
                      }}
                    ></hr>
                  </div>
                </div>

              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Test;
